import HundredBricksAPIError from '../../../HundredBricksAPIError';
class AutomationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AutomationError', ...args);
    }
}
export default AutomationError;
